import { createAddOnNameColumnDefinition, AddOnNameColumnId } from './columns/add-on-name';
import { createAddOnDescriptionColumnDefinition, AddOnDescriptionColumnId } from './columns/add-on-description';
import { createAddOnPriceColumnDefinition, AddOnPriceColumnId } from './columns/add-on-price';
import { createAddOnStatusColumnDefinition, AddOnStatusColumnId } from './columns/add-on-status';

export const columns = [
  createAddOnNameColumnDefinition(),
  createAddOnDescriptionColumnDefinition(),
  createAddOnPriceColumnDefinition(),
  createAddOnStatusColumnDefinition(),
];

export { AddOnNameColumnId, AddOnDescriptionColumnId, AddOnPriceColumnId, AddOnStatusColumnId };
